import { Box, Card, Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import React, { useMemo, useState } from 'react'

const LogBlock = ( { log } ) => {

    const [showDetails, setShowDetails] = useState( false )

    const { palette, border, shadows } = useTheme()

    const requestData = useMemo( () => {
        const data = { exists: false, dataAvailable: [] }
        if ( Object.keys( log?.meta?.body || {} ).length > 0 ) {
            data.body = log.meta.body
            data.exists = true
            data.dataAvailable.push( "body" )
        }
        if ( Object.keys( log?.meta?.params || {} ).length > 0 ) {
            data.params = log.meta.params
            data.exists = true
            data.dataAvailable.push( "params" )
        }
        if ( Object.keys( log?.meta?.query || {} ).length > 0 ) {
            data.query = log.meta.query
            data.exists = true
            data.dataAvailable.push( "query" )
        }
        return data
    }, [log] )

    return (
        <Card elevation={0} sx={{ border: border[1], ":hover": { boxShadow: shadows[1] } }} >
            <Box onClick={() => setShowDetails( prev => !prev )} sx={{ cursor: "pointer" }} padding="10px">
                <Box display="flex" gap="10px" alignItems="center">
                    {log?.meta?.module && <Typography fontSize="10px" borderRadius="5px" bgcolor={palette.primary.main} color={palette.primary.contrastText} border={border[1]} padding="2px 5px" variant='subtitle2'>{log.meta.module}</Typography>}
                    {log?.meta?.method && <Typography fontSize="10px" borderRadius="5px" bgcolor={palette.primary.main} color={palette.primary.contrastText} border={border[1]} padding="2px 5px" variant='subtitle2'>{log.meta.method}</Typography>}
                    <Typography fontSize="10px" borderRadius="5px" bgcolor={palette.contentBg} border={border[1]} padding="2px 5px" variant='subtitle2'>{log.level}</Typography>
                </Box>
                <Box>
                    <Typography textTransform="capitalize" fontSize="14px" > <em>{log.meta?.name?.toLowerCase()}  ({log.meta?.user_id || "NA"}), {log.meta?.user_role}</em> </Typography>
                    {<Typography textTransform="capitalize" fontSize="12px" ><Typography fontSize="inherit" component="strong" > {log?.meta?.action || ""}</Typography> <Typography fontSize="inherit" component="span" color='textSecondary'>{log?.message || log?.meta?.error?.message || ""}</Typography></Typography>}
                </Box>
                <Typography ></Typography>
            </Box>
            <Collapse in={showDetails}>
                <Box padding="10px">
                    <Typography>
                        <Box component="span" display="inline-flex" gap="10px" alignItems="center" border={border[1]} padding="2px 5px 4px 5px" borderRadius="5px" bgcolor={palette.contentBg}>
                            <Typography component="strong"> <em>{log?.meta?.method || "GET"}</em> </Typography> {log.meta?.endpoint}
                        </Box>
                    </Typography>
                    {/* <Typography>
                        <Box component="span" display="inline-flex" gap="10px" alignItems="center" border={border[1]} padding="2px 5px 4px 5px" borderRadius="5px" bgcolor={palette.contentBg}>
                            <Typography component="strong"> <em>{log.meta?.file?.split( "\\" ).at( -1 )}</em> </Typography>
                        </Box>
                    </Typography> */}

                    {requestData.exists && requestData.dataAvailable.map( data => (
                        <Box width="450px" key={data}>
                            <Typography marginTop="10px" variant='subtitle2' sx={{ fontWeight: "bold" }}>{data}</Typography>
                            <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, fontFamily: "inherit", maxHeight: "450px", overflow: "auto" }} className='slim-custom-scrollbar' component="pre" fontSize="10px" padding="10px" borderRadius="5px" bgcolor={palette.contentBg} >
                                {typeof requestData[data] === 'string' ? requestData[data] : JSON.stringify( requestData[data], null, 2 )}
                            </Box>
                        </Box>
                    ) )}

                    {( log?.meta?.error?.stack || log?.meta?.error?.message ) && <Box marginTop="20px" borderRadius="5px" border={`2px solid ${palette.error.main}`} >
                        <Typography padding="5px 10px" variant='subtitle2' sx={{ fontFamily: "monospace" }} bgcolor={palette.error.light + "33"} color="error.main"><em>Error</em></Typography>
                        {log?.meta?.error?.stack ? < Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, fontFamily: "inherit", maxHeight: "450px", overflow: "auto" }} className='slim-custom-scrollbar' overflow="auto" padding="10px" component="pre" flexGrow={1}>
                            {typeof log.meta.error.stack === 'string' ? log.meta.error.stack : JSON.stringify( log.meta.error.stack, null, 2 )}
                        </Box> : < Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, fontFamily: "inherit", maxHeight: "450px", overflow: "auto" }} className='slim-custom-scrollbar' overflow="auto" padding="10px" component="pre" flexGrow={1}>
                            {log?.meta?.error?.message}
                        </Box>}
                    </Box>}

                    {log?.meta?.type === "API" && log?.meta?.errorData && <Box marginTop="20px" borderRadius="5px" border={`2px solid ${palette.greyed.main}`} >
                        <Typography padding="5px 10px" variant='subtitle2' sx={{ fontFamily: "monospace" }} bgcolor={palette.greyed.light + "33"} color="greyed.main"><em>API Response</em></Typography>
                        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, fontFamily: "inherit", maxHeight: "450px", overflow: "auto" }} className='slim-custom-scrollbar' overflow="auto" padding="10px" component="pre" flexGrow={1}>
                            {typeof log.meta.errorData === 'string' ? log?.meta?.errorData : JSON.stringify( log.meta.errorData, null, 2 )}
                        </Box>
                    </Box>}

                    {log?.meta?.data && <Box display="flex" flexDirection="column" overflow="auto" maxHeight="300px" marginTop="20px" borderRadius="5px" border={`2px solid ${palette.greyed.main}`} >
                        <Typography padding="5px 10px" variant='subtitle2' bgcolor={palette.greyed.light + "33"} color="greyed.main"><em>Response</em></Typography>
                        <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, fontFamily: "inherit", maxHeight: "450px", overflow: "auto" }} className='slim-custom-scrollbar' padding="10px" component="pre" height="100%" flexGrow={1} overflow="auto" >
                            {log?.meta?.message}
                            {typeof log.meta.data === 'string' ? log.meta.data : JSON.stringify( log.meta.data, null, 2 )}
                        </Box>
                    </Box>}
                </Box>
            </Collapse>
        </Card>
    )
}

export default LogBlock
